import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Link from 'next/link';

import { BRAND } from '@/theme';
import { BrandIcon } from '@/components/brand-icon';

export const BRAND_NAME = 'DouBoard';

type BrandMarkProps = {
  size?: 'md' | 'lg';
  href?: string;
  // "light" is for dark backgrounds (the landing footer).
  tone?: 'dark' | 'light';
};

export function BrandMark({ size = 'md', href = '/', tone = 'dark' }: BrandMarkProps) {
  const box = size === 'lg' ? 40 : 32;
  const light = tone === 'light';
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1.2}
      component={Link}
      href={href}
      sx={{ textDecoration: 'none', color: light ? '#ffffff' : BRAND.ink }}
    >
      <BrandIcon size={box} />
      <Typography
        sx={{
          fontSize: size === 'lg' ? 22 : 19,
          fontWeight: 850,
          letterSpacing: '-0.045em',
          whiteSpace: 'nowrap'
        }}
      >
        {BRAND_NAME}<Typography component="span" sx={{ color: BRAND.pinkStrong, fontWeight: 900 }}>.</Typography>
      </Typography>
    </Stack>
  );
}
